import { toast } from "react-toastify";
import { TranslationErrorToast } from "./TranslationErrorToast";

// This directory is what the page says about its own translations. Its strings are in the `i18n`
// namespace (see `I18N_FILES` in packages/i18n/src/namespaces.ts): built into the app in every
// locale rather than fetched, so they are translated while the catalog is still loading, and after
// it failed to.

/**
 * A message catalog failed to load, after its own retries. The page still works, in English, so
 * this says why and stays until dismissed, with its own close button since some apps' containers
 * have none. Shown once however many catalogs fail together. Needs the app's react-toastify
 * `ToastContainer` mounted on every page that can show it.
 */
export const showTranslationErrorNotification = () => {
  toast(TranslationErrorToast, { autoClose: false, closeButton: true, toastId: "translation-error" });
};
